import { render, staticRenderFns } from "./ShootingStar.vue?vue&type=template&id=4640504d&scoped=true&"
import script from "./ShootingStar.vue?vue&type=script&lang=js&"
export * from "./ShootingStar.vue?vue&type=script&lang=js&"
import style0 from "./ShootingStar.vue?vue&type=style&index=0&id=4640504d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4640504d",
  null
  
)

export default component.exports